import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { HowItWorks } from "@/components/HowItWorks";
import { Products } from "@/components/Products";
import { Pricing } from "@/components/Pricing";
import { Partners } from "@/components/Partners";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <Products />
        <Pricing />
        <Partners />
      </main>
      <Footer />
    </div>
  );
}
